import React from 'react'
import { makeStyles, Box } from '@material-ui/core'
import "./styles/global.css"
import PublicLayout from '../../../layouts/PublicLayout'

// Sections
import { HeroSection } from './sections/HeroSection'
import { FeaturesSection } from './sections/FeaturesSection'
import { LifestyleSection } from './sections/LifestyleSection'
import { CuratedExcellenceSection } from './sections/CuratedExcellenceSection'
import { CreatorPerksSection } from './sections/CreatorPerksSection'
import { SignupSection } from './sections/SignupSection'

const useStyles = makeStyles((theme) => ({
    // Global root styles
    root: {
        fontFamily: "Roboto, Arial, sans-serif",
        backgroundColor: '#0a0a0a',
        color: '#ffffff',
        minHeight: '100vh',
        overflowX: 'hidden',
    },
}))

const GeneralLandingPage: React.FC = () => {
    const classes = useStyles()

    return (
        <PublicLayout>
            <Box className={classes.root}>
                <HeroSection />
                <FeaturesSection />
                <LifestyleSection />
                <CuratedExcellenceSection />
                <CreatorPerksSection />
                <SignupSection />
            </Box>
        </PublicLayout>
    )
}

export default GeneralLandingPage
